import { getPdfLink } from "@helsenorge/framework-utils/hn-tjeneste-service";
import type { BaseGetDokumentFilStreamV1Request } from "HNEntities/api-types";

export const openSkjemaSvarLink = (
  oppgaveSvarId: string | null,
  mimeType: string | undefined,
) => {
  if (mimeType === "application/pdf") {
    const commandData: BaseGetDokumentFilStreamV1Request = {
      DownloadMode: true,
      DokumentGuid: oppgaveSvarId,
    };
    const pdfLink = getPdfLink(
      "dokumenterinternal",
      "innbygger/dokument/fil/stream/v1",
      { ...commandData },
    );
    return pdfLink;
  }

  if (mimeType === "text/html") {
    const openLink = getPdfLink(
      "dokumenterinternal",
      "innbygger/dokument/fil/stream/v1",
      {
        DokumentGuid: oppgaveSvarId,
        error_response_type: "html",
      },
    );

    window.open(openLink, "_blank");
  }
  return "";
};
